import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";
import { ManageCourseData } from "../types/manageCourseContentTypes";

export async function adminManageCourseContentLoader({
  params,
}: LoaderFunctionArgs): Promise<ManageCourseData> {
  const courseId = params.courseId;
  if (!courseId) {
    throw new Error("courseId parametresi eksik");
  }
  try {
    const result = await apiEndpoints.lecturerGetCourseContent(courseId);
    if (!result.success) {
      throw new Error(result.message || "Kurs içeriği yüklenemedi");
    }
    return result.data;
  } catch (error) {
    console.error("Error loading course content:", error);
    throw new Error("Kurs içeriği yüklenemedi");
  }
}
